// One day as a vertical column of positioned meetings — the piece the day view and the
// week view are both built from, so a Tuesday looks identical whether you are looking at
// Tuesday alone or at the week around it.
//
// Clicking empty space books at that time. The click's position in the column is read back
// as a minute, snapped DOWN to the half-hour grid, which is the natural way to use a
// calendar and saves picking the time twice. It is only a prefill — the form still offers
// the free-slot picker, and the server still decides.
import { DAY_MINUTES, WORK_START, SLOT_MINUTES, placeInDay, asTime } from './workingDay';
import { layoutDay } from './layoutDay';
import MeetingChip from './MeetingChip';

export default function DayColumn({ date, meetings, partners, onOpen, onPickEmpty }) {
  const placed = layoutDay(meetings);

  const clickToTime = (e) => {
    // Only a click on the column itself, never one that bubbled up from a chip.
    if (e.target !== e.currentTarget) return;
    const box = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientY - box.top) / box.height;
    const raw = WORK_START + ratio * DAY_MINUTES;
    const snapped = Math.floor(raw / SLOT_MINUTES) * SLOT_MINUTES;
    const clamped = Math.min(Math.max(snapped, WORK_START), 24 * 60 - SLOT_MINUTES);
    onPickEmpty(date, asTime(clamped));
  };

  return (
    <div className="day-column" onClick={clickToTime}>
      {placed.map(({ meeting, start, end, lane, lanes }) => (
        <MeetingChip
          key={meeting.id}
          meeting={meeting}
          partners={partners}
          onClick={onOpen}
          compact={end - start <= SLOT_MINUTES}
          style={{
            ...placeInDay(start, end),
            // Lanes are laid out with `inset-inline`, so the same arithmetic works in RTL
            // without mirroring anything by hand.
            insetInlineStart: `${(lane / lanes) * 100}%`,
            width: `${(1 / lanes) * 100}%`,
          }}
        />
      ))}
    </div>
  );
}
